module.exports = __webpack_public_path__ + "static/media/bckbck-dark.3c997cfc.svg";